package com.example.borshi.web.model

data class Category(
    val emoji: String,
    val name: String,
    val description: String,
    val imageUrl: String,
    val id: String = ""
)

data class Product(
    val id: String = "",
    val name: String,
    val price: Double,
    val imageUrl: String,
    val category: String = "All",
    val tags: ProductTags = ProductTags(),
    val productInfo: ProductInfo = ProductInfo()
)

data class ProductTags(
    val waterType: List<String> = emptyList(),
    val boneType: List<String> = emptyList(),
    val benefit: List<String> = emptyList(),
    val cutType: List<String> = emptyList(),
    val omega3: List<String> = emptyList(),
    val minerals: List<String> = emptyList(),
    val vitamins: List<String> = emptyList(),
    val cookStyle: List<String> = emptyList(),
    val diet: List<String> = emptyList(),
    val spiceFit: List<String> = emptyList(),
    val handling: List<String> = emptyList(),
    val allergen: List<String> = emptyList()
)

data class ProductInfo(
    val culinaryProfile: String = "",
    val cookingTips: List<String> = emptyList(),
    val healthBenefits: List<String> = emptyList(),
    val cons: List<String> = emptyList(),
    val allergens: List<String> = emptyList(),
    val storageInstructions: String = "",
    val certifications: List<String> = emptyList()
) {
    val isPopulated: Boolean
        get() = culinaryProfile.isNotBlank()
                || healthBenefits.isNotEmpty()
                || cookingTips.isNotEmpty()
                || cons.isNotEmpty()
                || allergens.isNotEmpty()
                || storageInstructions.isNotBlank()
                || certifications.isNotEmpty()
}
